import React from "react";
import NavigateBeforeIcon from "@mui/icons-material/NavigateBefore";
import { AppButton, IAppButtonProps } from "ui/Scripts/source/components/framework/Button/AppButton";

interface IArrowLeftButtonProps extends IAppButtonProps {
    rotateIcon?: boolean;
}

export const ArrowLeftButton = (props: IArrowLeftButtonProps) => {
    const { rotateIcon, ...rest } = props;

    return (
        <AppButton
            variant="text"
            color="inherit"
            startIcon={<NavigateBeforeIcon sx={{ transform: !props.rotateIcon ? "none" : "rotate(180deg)" }} />}
            {...rest}
        >
            {props.children}
        </AppButton>
    );
};
